import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "@/messages/action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "@/messages/layout/sidebar";
import {
  LojaIntegradaAccountConnectionMessages,
  lojaIntegradaAccountConnectionMessages,
} from "@/messages/platforms/lojaIntegradaConnection/lojaIntegrada-account-connection.messages";
import {
  LojaIntegradaCompletionMessages,
  lojaIntegradaCompletionMessages,
} from "@/messages/platforms/lojaIntegradaConnection/lojaIntegrada-completion.messages";
import {
  LojaIntegradaOverviewMessages,
  lojaIntegradaOverviewMessages,
} from "@/messages/platforms/lojaIntegradaConnection/lojaIntegrada-overview.messages";

export type LojaIntegradaConnectionMessages = SidebarMessages &
  ActionButtonMessages &
  LojaIntegradaOverviewMessages &
  LojaIntegradaAccountConnectionMessages &
  LojaIntegradaCompletionMessages & {
    pageTitle: string;
    breadCrumbTitle: string;

    nextButton: string;
    completeButton: string;

    overviewStepTitle: string;
    accountConnectionStepTitle: string;
    completionStepTitle: string;
  };

export const LOJAINTEGRADA_CONNECTION_MESSAGES: LojaIntegradaConnectionMessages = {
  pageTitle: "Loja Integrada",
  breadCrumbTitle: "Plataformas",

  nextButton: "Próximo",
  completeButton: "Concluir",

  overviewStepTitle: "Visão Geral",
  accountConnectionStepTitle: "Conecte sua conta",
  completionStepTitle: "Finalização",

  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,

  ...lojaIntegradaOverviewMessages,
  ...lojaIntegradaAccountConnectionMessages,
  ...lojaIntegradaCompletionMessages,
};
